import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

export function strictEmailValidator(): ValidatorFn {
  const regex = /^[\w-\.]+@([\w-]+\.)+[\w-]{2,}$/;

  return (control: AbstractControl): ValidationErrors | null => {
    const value = control.value;
    if (!value) return null;

    return regex.test(value) ? null : { strictEmail: true };
  };
}
